// extracted by mini-css-extract-plugin
export default {"help_video_icon":"StudyMaterialHelpVideoButton_help_video_icon__UbQOH"};